import apiClient from './api';
import { AUTH_STORAGE_KEYS, AuthState, AuthUser, LoginRequest, LoginResponse, Rolle } from '../types/auth';

export const authService = {
  async login(credentials: LoginRequest): Promise<AuthState> {
    const response = await apiClient.post<LoginResponse>('/auth/login', credentials);
    const { token, user } = response.data;
    localStorage.setItem(AUTH_STORAGE_KEYS.token, token);
    localStorage.setItem(AUTH_STORAGE_KEYS.user, JSON.stringify(user));
    return { token, user };
  },

  logout(): void {
    localStorage.removeItem(AUTH_STORAGE_KEYS.token);
    localStorage.removeItem(AUTH_STORAGE_KEYS.user);
  },

  getStoredAuth(): AuthState {
    const token = localStorage.getItem(AUTH_STORAGE_KEYS.token);
    const userStr = localStorage.getItem(AUTH_STORAGE_KEYS.user);
    const user: AuthUser | null = userStr ? JSON.parse(userStr) : null;
    return { token, user };
  },

  isAdmin(user: AuthUser | null | undefined): boolean {
    return !!user && user.rolle === Rolle.ADMIN;
  }
};
